import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, IconButton } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';
import CustomForm from '../../../components/FormRenderer/CustomForm';

import {
  sanitizePayload,
  initializeFormData,
} from '../../../components/FormRenderer/utils';
import {
  createBuzzOneSchool,
  updateBuzzOneSchool,
  getAllBuzzOneSchools,
} from '../BuzzOneSlice';
import moment from 'moment';

export default function BuzzOneSchools() {
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleLoader } = useLoader();

  const [showFormModal, setFormModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [formTemplate, setFormTemplate] = useState(null);
  const [formData, setFormData] = useState({});

  const { schools } = useSelector(({ buzzOne }) => {
    return {
      schools: buzzOne.schools,
    };
  });

  useEffect(() => {
    dispatch(getAllBuzzOneSchools());
  }, []);

  useEffect(() => {
    if (selectedRowId) {
      let newFormData = JSON.parse(
        JSON.stringify(schools.filter((item) => item._id === selectedRowId)[0])
      );
      if (newFormData.address) {
        if (newFormData.address.addressLine)
          newFormData.addressLine = newFormData.address.addressLine;
        if (newFormData.address.city)
          newFormData.city = newFormData.address.city;
        if (newFormData.address.state)
          newFormData.state = newFormData.address.state;
        if (newFormData.address.country)
          newFormData.country = newFormData.address.country;
        if (newFormData.address.pincode)
          newFormData.pincode = newFormData.address.pincode;
        delete newFormData.address;
      }

      setFormData(newFormData);
    } else setFormData(initializeFormData(formTemplate));
  }, [selectedRowId]);

  useEffect(() => {
    const formTemplate = [
      {
        id: 'form.name',
        title: 'Name',
        slug: 'name',
        type: 'String',
        required: true,
      },
      {
        id: 'form.mobile',
        title: 'Contact Number',
        slug: 'mobile',
        type: 'String',
        required: true,
      },
      {
        id: 'form.email',
        title: 'Email Id',
        slug: 'email',
        type: 'String',
        required: true,
      },
      {
        id: 'form.address.addressLine',
        title: 'Address Line 1',
        slug: 'addressLine',
        type: 'String',
      },
      {
        id: 'form.address.city',
        title: 'City',
        slug: 'city',
        type: 'String',
      },
      {
        id: 'form.address.state',
        title: 'State',
        slug: 'state',
        type: 'String',
      },
      {
        id: 'form.address.country',
        title: 'Country',
        slug: 'country',
        type: 'String',
      },
      {
        id: 'form.address.pincode',
        title: 'Pincode',
        slug: 'pincode',
        type: 'String',
      },
    ];
    setFormTemplate(formTemplate);

    setFormData(initializeFormData(formTemplate));
  }, []);

  const schoolsColumn = [
    // { Header: 'SchoolId', accessor: '_id' },
    { Header: 'Name', accessor: 'name' },
    {
      Header: 'PII',
      Cell: (val) => {
        return (
          <>
            <p>{val.cell.row.original.email}</p>
            <p>{val.cell.row.original.mobile}</p>
          </>
        );
      },
    },
    {
      Header: 'Address',
      Cell: (val) => {
        const address = val.cell.row.original.address;
        return (
          <>
            {address && (
              <p style={{ maxWidth: '200px' }}>
                {address.addressLine && `${address.addressLine}`}
                {address.city && `, ${address.city}`}
                {address.pincode && `- ${address.pincode}`}
                <br />
                {address.state && `${address.state}, `}
                <br />
                {address.country && `${address.country}`}
              </p>
            )}
          </>
        );
      },
    },
    {
      Header: 'Action',
      Cell: (val) => {
        const { _id } = val.cell.row.original;

        return (
          <>
            <IconButton onClick={() => handleEdit(_id)}>
              <EditIcon color="secondary" />
            </IconButton>
          </>
        );
      },
    },
  ];

  const openFormModal = () => setFormModal(true);
  const closeFormModal = () => setFormModal(false);

  const handleEdit = (id) => {
    setSelectedRowId(id);
    openFormModal();
  };

  const handleCreateNew = () => {
    setSelectedRowId(null);
    openFormModal();
  };

  const handleSave = async () => {
    handleLoader(true);
    let payload = sanitizePayload(formData);

    dispatch(
      selectedRowId === null
        ? createBuzzOneSchool(payload)
        : updateBuzzOneSchool({ id: selectedRowId, data: payload })
    )
      .unwrap()
      .then((res) => {
        SuccessToast(res.message);
        dispatch(getAllBuzzOneSchools());
        closeFormModal();
      })
      .catch((error) => {
        console.error('rejected', error);
        ErrorToast(error.message);
      });

    handleLoader(false);
  };

  return (
    <Box>
      <Button onClick={handleCreateNew} variant={'contained'} color="primary">
        Add School
      </Button>
      <Box my={2}>
        <BuzzTable
          columns={schoolsColumn}
          data={schools}
          isHandlePagination={true}
        />
      </Box>
      <Modal open={showFormModal} onClose={closeFormModal}>
        <CustomForm
          formFor={'School'}
          formTemplate={formTemplate}
          formData={formData}
          setFormData={(slug, newValue) => {
            setFormData((state) => {
              state[slug] = newValue;
              return state;
            });
            setFormTemplate((state) => {
              return JSON.parse(JSON.stringify(state));
            });
          }}
          mode={selectedRowId === null ? 'CREATE' : 'EDIT'}
          handleSave={handleSave}
        />
      </Modal>
    </Box>
  );
}
